import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/layout/Header'
import Sidebar from '../../components/layout/Sidebar'
import { Link } from 'react-router-dom';
import ListDealerForOrder from '../../components/scheduleManagement/ListDealerForOrder';

const OrderListSchedule = ({ nav }) => {
    const dispatch = useDispatch()
    const userLogin = useSelector((state) => state.userSignIn);
    const { userInfo } = userLogin;



    return (
        <>
            <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                <main className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center">
                        <div className="breadcrumb-title pe-3 text-white">Schedule Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to='/'>
                                            <i className="bx bx-home-alt text-white" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Dealer Based Orders to Schedule
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                   <ListDealerForOrder nav={nav}  />
                </main>
            </div>
        </>
    )
}

export default OrderListSchedule